var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useRetrieveUserIntraSquadTournamentPermissions } from "../api/PermissionApiProvider";
import { useBulkUpdatePlayerIntraSquadTournamentMatchStats, useCreateIntraSquadTournamentMatchResult, useRetrieveIntraSquadTournamentMatch, useUpdateIntraSquadTournamentMatchResult, } from "../api/TournamentApiProvider";
import { useRetrievePlayersByTeamId, useRetrieveTeam, useRetrieveUserTeamPermissions, } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import { IntraSquadTournamentMatchStatsForm } from "../stats/IntraSquadTournamentMatchStatsForm";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
export var UpdatePlayerIntraSquadTournamentMatchStats = function () {
    var id = useNumericParams().id;
    var _a = useRetrieveIntraSquadTournamentMatch({ id: id }), useRetrieveIntraSquadTournamentMatchIsLoading = _a.isLoading, useRetrieveIntraSquadTournamentMatchError = _a.error, intraSquadTournamentMatch = _a.data;
    var _b = useRetrieveUserIntraSquadTournamentPermissions({
        tournamentId: intraSquadTournamentMatch === null || intraSquadTournamentMatch === void 0 ? void 0 : intraSquadTournamentMatch.tournament,
    }), userTournamentPermissions = _b.data, userTournamentPermissionsIsLoading = _b.isLoading, userTournamentPermissionsError = _b.error;
    var _c = useRetrieveUserTeamPermissions({
        teamId: intraSquadTournamentMatch === null || intraSquadTournamentMatch === void 0 ? void 0 : intraSquadTournamentMatch.team,
    }), userTeamPermissions = _c.data, userTeamPermissionsIsLoading = _c.isLoading, userTeamPermissionsError = _c.error;
    var _d = (userTournamentPermissions || {}).canModifyStats, canModifyTournamentStats = _d === void 0 ? false : _d;
    var _e = (userTeamPermissions || {}).canModifyStats, canModifyTeamStats = _e === void 0 ? false : _e;
    // Stats entry needs stats-write permission (manager or assistant manager),
    // not full team-modify rights.
    var canModify = canModifyTournamentStats || canModifyTeamStats;
    var _f = useRetrievePlayersByTeamId({
        teamId: intraSquadTournamentMatch === null || intraSquadTournamentMatch === void 0 ? void 0 : intraSquadTournamentMatch.team,
        enabled: canModify,
    }), players = _f.data, playersError = _f.error, playersIsLoading = _f.isLoading;
    var navigate = useNavigate();
    var _g = useBulkUpdatePlayerIntraSquadTournamentMatchStats(intraSquadTournamentMatch, function () { }, function () { return undefined; }, function (error) {
        console.log(error);
    }), useUpdateIntraSquadTournamentMatchStatsIsLoading = _g.isLoading, useUpdateIntraSquadTournamentMatchStatsIsError = _g.isError, useBulkUpdatePlayerIntraSquadTournamentMatchStatsMutateAsync = _g.mutateAsync;
    var _h = useUpdateIntraSquadTournamentMatchResult(intraSquadTournamentMatch, function () { }, function () { return undefined; }, function (error) {
        console.log(error);
    }), useUpdateIntraSquadTournamentMatchResultIsLoading = _h.isLoading, useUpdateIntraSquadTournamentMatchResultMutateAsyncIsError = _h.isError, useUpdateIntraSquadTournamentMatchResultMutateAsync = _h.mutateAsync;
    var _j = useRetrieveTeam({
        id: intraSquadTournamentMatch === null || intraSquadTournamentMatch === void 0 ? void 0 : intraSquadTournamentMatch.team,
        enabled: canModify,
    }), team = _j.data, teamIsLoading = _j.isLoading, teamError = _j.error;
    var _k = useCreateIntraSquadTournamentMatchResult(intraSquadTournamentMatch, function () { }, function () { return undefined; }, function (error) {
        console.log(error);
    }), useCreateIntraSquadTournamentMatchResultIsLoading = _k.isLoading, useCreateIntraSquadTournamentMatchResultMutateAsyncIsError = _k.isError, useCreateIntraSquadTournamentMatchResultMutateAsync = _k.mutateAsync;
    // Check permissions loading states first, before any data loading
    if (userTournamentPermissionsIsLoading || userTeamPermissionsIsLoading) {
        return _jsx(Loading, {});
    }
    // Check permissions error states first
    if (userTournamentPermissionsError || userTeamPermissionsError) {
        return (_jsx(ErrorView, { error: userTournamentPermissionsError || userTeamPermissionsError }));
    }
    // Check tournament match loading/error after permissions
    if (useRetrieveIntraSquadTournamentMatchIsLoading) {
        return _jsx(Loading, {});
    }
    if (useRetrieveIntraSquadTournamentMatchError) {
        return _jsx(ErrorView, { error: useRetrieveIntraSquadTournamentMatchError });
    }
    // Check permissions before proceeding with any other data fetching
    if (!canModify) {
        return _jsx(Forbidden, {});
    }
    // Now check secondary data loading states (only if permissions allow)
    if (useUpdateIntraSquadTournamentMatchStatsIsLoading ||
        useUpdateIntraSquadTournamentMatchResultIsLoading ||
        useCreateIntraSquadTournamentMatchResultIsLoading ||
        playersIsLoading ||
        teamIsLoading) {
        return _jsx(Loading, {});
    }
    // Check secondary data error states (only if permissions allow)
    if (playersError || teamError) {
        return _jsx(ErrorView, { error: playersError || teamError });
    }
    var onSubmit = function (intraSquadTournamentMatchResult, playerIntraSquadTournamentMatchStats) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, useBulkUpdatePlayerIntraSquadTournamentMatchStatsMutateAsync(Object.values(playerIntraSquadTournamentMatchStats))];
                case 1:
                    _a.sent();
                    if (!((intraSquadTournamentMatch === null || intraSquadTournamentMatch === void 0 ? void 0 : intraSquadTournamentMatch.intraSquadTournamentMatchResult) === null)) return [3 /*break*/, 3];
                    return [4 /*yield*/, useCreateIntraSquadTournamentMatchResultMutateAsync(intraSquadTournamentMatchResult)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, useUpdateIntraSquadTournamentMatchResultMutateAsync(intraSquadTournamentMatchResult)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    navigate("/teams/".concat(intraSquadTournamentMatch.team, "/intra-squad-tournaments/").concat(intraSquadTournamentMatch.tournament, "/"));
                    return [2 /*return*/];
            }
        });
    }); };
    var error = useRetrieveIntraSquadTournamentMatchError || playersError || teamError;
    if (error) {
        return _jsx(ErrorView, { error: error });
    }
    if (!team || players === undefined || !intraSquadTournamentMatch) {
        return (_jsx(ErrorView, { error: new Error("Failed to load user data correctly.") }));
    }
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: useUpdateIntraSquadTournamentMatchResultMutateAsyncIsError, message: "Failed to update intra-squad-match result! Please try again." }), _jsx(ErrorSnackbar, { open: useCreateIntraSquadTournamentMatchResultMutateAsyncIsError, message: "Failed to create intra-squad-match result! Please try again." }), _jsx(ErrorSnackbar, { open: useUpdateIntraSquadTournamentMatchStatsIsError, message: "Failed to create player intra-squad-match stats! Please try again." }), _jsx(Typography, { variant: "h6", children: _jsxs("strong", { children: ["Intra-Squad Match Stats for Team ", team.name] }) }), _jsx(Typography, { variant: "subtitle2", children: format(new Date(intraSquadTournamentMatch.kickOff), "MMMM do yyyy @ H:mma") }), _jsx(IntraSquadTournamentMatchStatsForm, { players: players, onSubmit: onSubmit, intraSquadTournamentMatch: intraSquadTournamentMatch })] }));
};
